import React from 'react'
import PhoneInputComponent, { isValidPhoneNumber, Country } from 'react-phone-number-input'
import flags from 'react-phone-number-input/flags'
import 'react-phone-number-input/style.css'

import * as S from './styles'

interface PhoneInputProps {
  cellPhone: string
  defaultCountry?: Country
  disabled?: boolean
  onChangePhone: (value: string) => void
} 

export const handleValidPhoneNumber = (cellphone: string): boolean => isValidPhoneNumber(cellphone)

export const PhoneInput: React.FC<PhoneInputProps> = ({
  cellPhone,
  defaultCountry = 'BR',
  disabled,
  onChangePhone
}) => {
  
  return (
    <S.Container disabled={disabled}>
      <PhoneInputComponent
        defaultCountry={defaultCountry}
        autoComplete="off"
        disabled={disabled}
        limitMaxLength
        onChange={(value: string) => onChangePhone(value)}
        placeholder="(00) 0 0000-0000"
        id="phone"
        value={cellPhone}
        flags={flags}
      />
    </S.Container>
  )
}